import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "description"
  ]
  boundSanitizeInput = this.sanitizeInput.bind(this);

  connect() {
    this.inputElement = this.inputTarget;
    this.inputElement.addEventListener('input', this.boundSanitizeInput);
  }

  disconnect() {
    this.inputElement.removeEventListener('input', this.boundSanitizeInput);
  }

  sanitizeInput(event) {
    const sanitized = event.target.value.replace(/[^a-zA-Z0-9_]/g, '');
    event.target.value = sanitized;
  }

  remove(event) {
    this.element.remove()
    event.preventDefault();
    return false;
  }
}
